import { Value, FontSize, FontWeight, Color } from 'theme/style'

const style = {
  root: {
    borderRadius: Value.BorderRadius,
    minHeight: '0px',
    textAlign: 'left',
    fontSize: FontSize.Body2,
    color: Color.TextPrimary,
    fontWeight: FontWeight.Medium,

  }
}

export default style
